import { mergeStyles } from '@fluentui/react';
import { ComponentSlotStyle } from '@fluentui/react-northstar';
const chatAreaContainerStyle = mergeStyles({
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',
  overflow: "hidden",
  display: 'flex',
  boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.03), 0px 6.4px 14.4px rgba(0, 0, 0, 0.07)'
});

const MessageBarStyle = mergeStyles({
  width: '100%',
  padding: '10px 20px',
  boxSizing: ' border-box',
  borderBottom: '1px solid #E1DFDD',
  overflow:"hidden"
});

const mRightStyle = mergeStyles({
});

const chatStyle: ComponentSlotStyle = {
  left: '16px',
  right: '6px',
  top: '29px',
  bottom: '13px',
  fontFamily: ' Abel',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '20px',

  color: '#252423'
};

const chatMessageStyle = (mine: Boolean): ComponentSlotStyle => ({
  backgroundColor: mine ? '#E5E5F1' : '#FFFFFF',
  overflowY: 'hidden'
});

const IconsStyle = mergeStyles({
  display: 'block',
  width: '14px',
  height: '14px',
  color: ' #212121',
  textAlign: 'center',
  lineHeight: '14px',
  fontSize: '14px',
  FontWeights: '600'
});
const chatContainerStyle = mergeStyles({
  height: '100%',
  width: '100%',
  maxHeight: '100%',
  overflow: 'auto'
});
const ExpressionBoxStyle = mergeStyles({
  listStyle: 'none',
  padding: '8px',
  boxSizing: 'border-box',
  border: '1px solid #eeeeee',
  margin:"0px",
  background: '#ffffff',
  display: 'flex',
  flexWrap: 'wrap'
});

const emojiItemStyle = mergeStyles({
  cursor: 'pointer',
  margin: '6px',
  fontSize:"18px",
  ':hover': {
    transform: 'scale(1.2)'
  }
});
const inputIcon = mergeStyles({
  cursor: 'pointer',
  ':hover': {
    transform: 'scale(1.2)'
  }
});


export {
  chatAreaContainerStyle,
  MessageBarStyle,
  inputIcon,
  mRightStyle,
  chatStyle,
  chatMessageStyle,
  IconsStyle,
  chatContainerStyle,
  ExpressionBoxStyle,
  emojiItemStyle
};
